import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer } from 'react'
import { useTypedSelector } from '../../redux/store'
import { usePageCache, useSkipInitEffect } from '../../tools/utilHooks'
import { AllowAccountRes, BATCH_ACCOUNT } from '../../api/orderManage'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import reducer, {
  setDataSource,
  setFormDataAction,
  setIsAddModalVisivle,
  setSelectedRowKeys,
  setIsSubmitButtonLoadingAction,
  setRouteParamsAction,
  reloadStateAction,
  initialState,
  setOriginRemovedListAction,
  setSelectedRows,
} from './pageReducer'
import { setModuleDataAction } from '../../modules/pagecache'
import { CustomerConfirm } from '../../components/ModalUser'
import { isResponseCodeSuccess } from '../../tools/util'

export interface RouteParams {
  data: AllowAccountRes[]
  id?: string // 存在时为修改
  rejectReason?: string // 驳回原因
  remark?: string // 供应商备注
}

export default function useHook() {
  const { enterpriseInfo } = useTypedSelector((state) => state.homeData)
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    dataSource,
    selectedRowKeys,
    selectedRows,
    routeParams,
    originRemovedList,
  } = state
  const dispatchRedux = useDispatch()
  const totalPrice = useMemo(
    () =>
      dataSource
        .map((item) => item.finalPrice)
        .reduce((x, y) => {
          return x + y
        }, 0),
    [dataSource],
  )
  const { closeCurrentTab } = usePageCache()
  const [form] = Form.useForm()
  const { state: routeState, pathname } = useLocation<RouteParams>()
  const CACHE_KEY = pathname
  const { pagekey } = useTypedSelector((state) => state.pageCache)

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !routeState) {
      dispatch(reloadStateAction(flag))
      form.setFieldsValue(flag.formData)
    } else if (routeState) {
      form.setFieldsValue(routeState)
      dispatch(setRouteParamsAction(routeState))
      dispatch(setDataSource(routeState.data))
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    dispatch(setIsSubmitButtonLoadingAction(true))
    const res = await BATCH_ACCOUNT({
      id: routeParams.id,
      orderIds: dataSource.map((item) => item.id),
      price: totalPrice.toFixed(2),
      remark: formValues.remark,
    })
    dispatch(setIsSubmitButtonLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      handleClosePage()
    }
  }

  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivle(false))
  }

  // 表格选中操作
  const onChangeCheck = (selectedRowKeys: any[], selectedRows: any[]) => {
    dispatch(setSelectedRowKeys(selectedRowKeys))
    dispatch(setSelectedRows(selectedRows))
  }

  const handleAddClick = () => {
    dispatch(setIsAddModalVisivle(true))
  }

  const handleAddFinished = (selectedRows: AllowAccountRes[]) => {
    dispatch(setDataSource([...dataSource, ...selectedRows]))
    dispatch(setIsAddModalVisivle(false))
    setOriginRemovedList(
      originRemovedList.filter(
        (item) => selectedRows.findIndex((e) => e.id === item.id) === -1,
      ),
    )
  }

  const handleClosePage = () => {
    closeCurrentTab()
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  // 删除
  const onDelete = () => {
    if (!selectedRowKeys.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
      onOk: () => {
        dispatch(
          setDataSource(
            dataSource.filter((item) => !selectedRowKeys.includes(item.id)),
          ),
        )
        setOriginRemovedList(
          selectedRows.filter((item) => item.type === 'origin'),
        )
        dispatch(setSelectedRowKeys([]))
        dispatch(setSelectedRows([]))
      },
    })
  }

  const setOriginRemovedList = (val: AllowAccountRes[]) => {
    dispatch(setOriginRemovedListAction(val))
  }

  return {
    form,
    hooksState: state,
    totalPrice,
    enterpriseInfo,
    handleAddClick,
    handleAddOrderModalCancel,
    handleAddFinished,
    handleSubmit,
    onChangeCheck,
    handleClosePage,
    handleFormDataChange,
    onDelete,
  }
}
import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer } from 'react'
import { useTypedSelector } from '../../redux/store'
import { usePageCache, useSkipInitEffect } from '../../tools/utilHooks'
import { AllowAccountRes, BATCH_ACCOUNT } from '../../api/orderManage'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import reducer, {
  setDataSource,
  setFormDataAction,
  setIsAddModalVisivle,
  setSelectedRowKeys,
  setIsSubmitButtonLoadingAction,
  setRouteParamsAction,
  reloadStateAction,
  initialState,
  setOriginRemovedListAction,
  setSelectedRows,
} from './pageReducer'
import { setModuleDataAction } from '../../modules/pagecache'
import { CustomerConfirm } from '../../components/ModalUser'
import { isResponseCodeSuccess } from '../../tools/util'

export interface RouteParams {
  data: AllowAccountRes[]
  id?: string // 存在时为修改
  rejectReason?: string // 驳回原因
  remark?: string // 供应商备注
}

export default function useHook() {
  const { enterpriseInfo } = useTypedSelector((state) => state.homeData)
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    dataSource,
    selectedRowKeys,
    selectedRows,
    routeParams,
    originRemovedList,
  } = state
  const dispatchRedux = useDispatch()
  const totalPrice = useMemo(
    () =>
      dataSource
        .map((item) => item.finalPrice)
        .reduce((x, y) => {
          return x + y
        }, 0),
    [dataSource],
  )
  const { closeCurrentTab } = usePageCache()
  const [form] = Form.useForm()
  const { state: routeState, pathname } = useLocation<RouteParams>()
  const CACHE_KEY = pathname
  const { pagekey } = useTypedSelector((state) => state.pageCache)

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !routeState) {
      dispatch(reloadStateAction(flag))
      form.setFieldsValue(flag.formData)
    } else if (routeState) {
      form.setFieldsValue(routeState)
      dispatch(setRouteParamsAction(routeState))
      dispatch(setDataSource(routeState.data))
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    dispatch(setIsSubmitButtonLoadingAction(true))
    const res = await BATCH_ACCOUNT({
      id: routeParams.id,
      orderIds: dataSource.map((item) => item.id),
      price: totalPrice.toFixed(2),
      remark: formValues.remark,
    })
    dispatch(setIsSubmitButtonLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      handleClosePage()
    }
  }

  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivle(false))
  }

  // 表格选中操作
  const onChangeCheck = (selectedRowKeys: any[], selectedRows: any[]) => {
    dispatch(setSelectedRowKeys(selectedRowKeys))
    dispatch(setSelectedRows(selectedRows))
  }

  const handleAddClick = () => {
    dispatch(setIsAddModalVisivle(true))
  }

  const handleAddFinished = (selectedRows: AllowAccountRes[]) => {
    dispatch(setDataSource([...dataSource, ...selectedRows]))
    dispatch(setIsAddModalVisivle(false))
    setOriginRemovedList(
      originRemovedList.filter(
        (item) => selectedRows.findIndex((e) => e.id === item.id) === -1,
      ),
    )
  }

  const handleClosePage = () => {
    closeCurrentTab()
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  // 删除
  const onDelete = () => {
    if (!selectedRowKeys.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
      onOk: () => {
        dispatch(
          setDataSource(
            dataSource.filter((item) => !selectedRowKeys.includes(item.id)),
          ),
        )
        setOriginRemovedList(
          selectedRows.filter((item) => item.type === 'origin'),
        )
        dispatch(setSelectedRowKeys([]))
        dispatch(setSelectedRows([]))
      },
    })
  }

  const setOriginRemovedList = (val: AllowAccountRes[]) => {
    dispatch(setOriginRemovedListAction(val))
  }

  return {
    form,
    hooksState: state,
    totalPrice,
    enterpriseInfo,
    handleAddClick,
    handleAddOrderModalCancel,
    handleAddFinished,
    handleSubmit,
    onChangeCheck,
    handleClosePage,
    handleFormDataChange,
    onDelete,
  }
}
